module.exports = __webpack_public_path__ + "img/image30.35b7e4cc.jpg";